import { render, staticRenderFns } from "./listactivity.vue?vue&type=template&id=57af4132&"
import script from "./listactivity.vue?vue&type=script&lang=js&"
export * from "./listactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports